<template>
  <div class="body flex ai_c">
    <div class="w40">
      <div class="plate_title">
        <div class="plate_title_name">抖音新箱图</div>
      </div>
      <div class="overflow_y" style="height: calc(100vh - 54px)">
        <div class="bb p20">
          <div class="flex">
            <div class="w100">
              <el-form ref="form" :model="form" label-width="90px">
                <el-form-item label="研究员">
                  <el-select
                    v-model="form.user_id"
                    class="m-2"
                    placeholder="请选择研究员"
                    size="mini"
                    clearable
                    @change="changeUserId"
                  >
                    <el-option
                      v-for="item in teacherList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="分类">
                  <el-select
                    v-model="form.category_id"
                    class="m-2"
                    placeholder="请选择分类"
                    size="mini"
                    clearable
                  >
                    <el-option
                      v-for="item in categoryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="图片">
                  <el-upload
                    class="avatar-uploader"
                    action="https://api.i-vce.com/teacher/common/upload"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                  >
                    <div class="avatar-uploader_div" v-if="form.image">
                      <img :src="form.image" class="avatar" />
                      <div class="zhezhao">
                        <el-icon @click.stop="handleRemove" :size="24">
                          <Delete color="#ffffff" />
                        </el-icon>
                      </div>
                    </div>
                    <el-icon v-else class="avatar-uploader-icon">
                      <Plus />
                    </el-icon>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-button
                    :loading="loadingBtn"
                    type="primary"
                    @click="addInfo"
                    >添加</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w60">
      <div class="plate_title">
        <div class="plate_title_name">历史记录</div>
      </div>
      <div class="quotation_body">
        <div class="flex ai_c bb pt10 pb10">
          分类
          <div class="ml10">
            <el-select v-model="category_id" class="m-2" size="mini" clearable>
              <el-option
                v-for="item in allCategoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="ml10">
            <el-button @click="getDouyinImageList" type="primary"
              >搜索</el-button
            >
          </div>
        </div>
        <div v-if="imageList.length" class="image_group overflow_y">
          <div
            class="image_box"
            v-for="(item, index) in imageList"
            :key="index"
          >
            <div class="image_cell">
              <el-image
                class="cover_img can"
                :src="item.image"
                :preview-src-list="[item.image]"
                fit="cover"
              >
              </el-image>
            </div>
            <div class="bottom_cell">
              <div class="hang1" :title="item.category.name">
                分类：{{ item.category.name }}
              </div>
            </div>
            <div class="bottom_cell">
              <div>{{ item.createtime_text }}</div>
              <div @click="showDeleteConfirm(item.id)" class="btn_delete">
                删除
              </div>
            </div>
          </div>
        </div>
        <el-empty v-else description="描述文字"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import data from "@/utils/data";
import { Delete, Plus } from "@element-plus/icons-vue";
const OSS = require("ali-oss");
import html2canvas from "html2canvas";
export default {
  components: {
    Plus,
    Delete,
  },
  data() {
    return {
      typeArr: [],
      varietiesArr: [],
      titleArr: [],
      researcherArr: [],

      currentTypeIndex: null,
      currentVarietiesIndex: null,
      currentTitleIndex: null,
      currentResearcherIndex: null,

      currentTypeId: null,
      currentVarietiesId: null,
      currentTitleId: null,
      currentResearcherId: null,

      quotationList: [],
      page: 1,
      quotationListloading: false, //客户列表加载状态
      isEnd: false,

      form: {
        user_id: null,
        category_id: null,
        image: "",
      },
      copytext: "",
      exchangeArr: [], // 交易所数组

      viewTypeArr: [
        {
          label: "全部",
          value: "all",
        },
        {
          label: "国内期货",
          value: "internal",
        },
        {
          label: "国际期货",
          value: "international",
        },
      ], // 检索类型条件
      viewType: "all",
      type_list: [], // 类别数组

      currentDate: "",
      currentTime: "",
      loadingBtn: false,

      userinfo: {},
      teacherList: [],
      categoryList: [],
      allCategoryList: [],
      category_id: null,
      imageList: [],
    };
  },
  mounted() {
    let that = this;
    window.onmessageSocket = this.onmessage;

    this.getUserIndex();
    this.getAllCategoryList();
    this.getDouyinImageList();

    // this.getSendTime();
    // setInterval(() => {
    //   this.getSendTime();
    // }, 1000 * 10);
    // this.typeArr = data.typeArr;
    // this.varietiesArr = data.varietiesArr;
    // this.titleArr = data.titleArr;
    // this.dataInit();
    // this.getExchangeArr();
    // this.getViewpointList();

    // this.copytext =
    //   "★内部技术指标课程研究\n【品种技术】：\n【技术名称】：\n【技术显示】：\n【空间预期】：\n【研究时间】：";
    // this.showRealTime();
    // 创建粘贴事件
    document.addEventListener("paste", function (e) {
      if (!(e.clipboardData && e.clipboardData.items)) {
        return;
      }
      for (var i = 0, len = e.clipboardData.items.length; i < len; i++) {
        var item = e.clipboardData.items[i];

        if (item.kind === "string") {
          item.getAsString(function (str) {
            console.log("str", str);
            // str 是获取到的字符串
          });
        } else if (item.kind === "file") {
          var pasteFile = item.getAsFile();
          console.log("pasteFile", pasteFile);

          let client = new OSS({
            // region以杭州为例（oss-cn-hangzhou），其他region按实际情况填写。
            region: "oss-cn-shanghai",
            // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
            accessKeyId: "LTAI5tRozUZ3WynSFfTzC72S",
            accessKeySecret: "HGfPDLd6zylQVVU7c9tkQT7uGKpRd7",
            bucket: "i-vce",
          });
          var name = that.getFileName(pasteFile);
          client
            .put(name, pasteFile)
            .then(function (res) {
              // 上传图片，返回结果，将图片插入到编辑器中
              console.log("res", res);
              that.form.image = res.url;

              let reader = new FileReader(); //实例化文件读取对象
              reader.readAsDataURL(pasteFile); //将文件读取为 DataURL,也就是base64编码
              reader.onload = (e) => {
                //文件读取成功完成时触发
                let dataURL = e.target.result; //获得文件读取成功后的DataURL,也就是base64编码
                that.form.images_base64 = dataURL;
              };
            })
            .catch(function (err) {
              console.log(err);
            });
          // that.uploadImg(pasteFile);
          // pasteFile就是获取到的文件
        }
      }
    });
  },
  methods: {
    onmessage(e) {},
    async getUserIndex() {
      const res = await request.post("/teacher/user/index");
      this.userInfo = res.data.userinfo;

      this.getTeacherList();
    },
    async getTeacherList() {
      const res = await request.post("/teacher/douyin_image/getTeacherList");
      const teacherList = res.data;
      const userInfo = this.userInfo;
      for (const item of teacherList) {
        if (item.id == userInfo.id) {
          this.form.user_id = item.id;
          break;
        }
      }
      this.teacherList = teacherList;

      if (this.form.user_id) {
        this.getCategoryList();
      }
    },
    changeUserId() {
      this.form.category_id = null;
      this.getCategoryList();
    },
    // 获取分类列表
    async getCategoryList() {
      const res = await request.post("/teacher/douyin_image/getCategoryList", {
        user_id: this.form.user_id,
      });
      const categoryList = res.data;
      if (categoryList.length) {
        this.form.category_id = categoryList[0].id;
      }
      this.categoryList = res.data;
    },
    // 获取分类列表
    async getAllCategoryList() {
      const res = await request.post("/teacher/douyin_image/getCategoryList", {
        user_id: "",
      });
      this.allCategoryList = res.data;
    },
    // 获取抖音图片列表
    async getDouyinImageList() {
      const res = await request.post(
        "/teacher/douyin_image/getDoyinImageList",
        {
          category_id: this.category_id,
        }
      );
      this.imageList = res.data;
    },
    showDeleteConfirm(id) {
      this.$confirm("确认删除该数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.handleDeleteApi(id);
      });
    },
    async handleDeleteApi(id) {
      const res = await request.post("/teacher/douyin_image/delDouyinImage", {
        id,
      });
      this.$message.success(res.msg);
      this.getDouyinImageList();
    },
    // 获取交易所列表
    async getExchangeArr() {
      const res = await request.post("/teacher/view_point_teacher/getBaseInfo");
      this.exchangeArr = res.data.exchangeArr;
      this.type_list = res.data.type_list;
    },
    // 选择交易所
    changeExchange(e) {
      var exchangeArr = this.exchangeArr;
      for (const item of exchangeArr) {
        if (item.id == e) {
          this.form.exchange_name = item.name;
        }
      }
    },
    // 获取时间信息
    getSendTime() {
      var d = new Date();
      // var year = d.getFullYear();
      var month =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      // var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      var cori_date = month + "-" + date;
      var cori_time = hour + ":" + min;
      this.currentDate = cori_date;
      this.currentTime = cori_time;

      return cori_date + " " + cori_time;
    },
    // 获取图片名称
    getFileName(file) {
      var d = new Date();
      var year = d.getFullYear();
      var month =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var type = file.type.substr(
        file.type.lastIndexOf("/") + 1,
        file.type.length
      );
      return (
        "push/hangqing/" +
        year +
        month +
        date +
        "/" +
        Math.round(new Date()) +
        "." +
        type
      );
    },
    async uploadImg(pasteFile) {
      const res = await request.post("/teacher/common/upload", {
        file: pasteFile,
      });
      console.log("res", res);
    },
    showRealTime() {
      var d = new Date();
      var year = d.getFullYear();
      var month =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var days = new Array("日", "一", "二", "三", "四", "五", "六");
      var day = d.getDay();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      var cori_date = year + "年" + month + "月" + date + "日";
      var cori_time = hour + ":" + min + ":" + sec;
      this.copytext += cori_date;
      1;
      // this.currentTime = cori_time;
      // this.currentWeek = "星期" + days[day];
    },
    copyText() {
      this.$copyText(this.copytext)
        .then((message) => {
          this.$message.success("复制完毕");
        })
        .catch((err) => {
          console.log("copy.err", err);
          this.$message.error("复制失败");
        });
    },
    handleRemove() {
      console.log("@删除图片");
      this.form.image = "";
    },
    handleAvatarSuccess(res, file) {
      this.form.image = res.data.fullurl;
      let reader = new FileReader(); //实例化文件读取对象
      reader.readAsDataURL(file.raw); //将文件读取为 DataURL,也就是base64编码
      reader.onload = (e) => {
        //文件读取成功完成时触发
        let dataURL = e.target.result; //获得文件读取成功后的DataURL,也就是base64编码
        this.form.images_base64 = dataURL;
      };
    },
    addInfo() {
      this.loadingBtn = true;
      setTimeout(() => {
        this.loadingBtn = false;
      }, 2000);
      this.onSubmit();
    },
    async onSubmit() {
      let that = this;
      var form = { ...that.form };
      if (!form.category_id) {
        that.$message.error("请选择分类");
        return false;
      }
      if (!form.image) {
        that.$message.error("请上传图片");
        return false;
      }
      const res = await request.post(
        "/teacher/douyin_image/addDouyinImage",
        form
      );
      that.$message.success("操作成功");
      that.form = {
        user_id: null,
        category_id: null,
        image: "",
      };
      that.getTeacherList();
      that.getDouyinImageList();
      that.loadingBtn = false;
    },
    async uploadBase64(pic) {
      const res = await request.post("/teacher/common/uploadBase64", {
        pic,
      });
      this.form.poster = res.data.url;
      console.log("res.data.url", res.data.url);
      this.onSubmit();
    },
    async dataInit() {
      const res = await request.post("/teacher/policy_notice/getBaseInfo");
      this.researcherArr = res.data.teacherList;
    },
    //获取行情
    async getViewpointList(page) {
      if (!this.isEnd) {
        this.quotationListloading = true;
        const res = await request.post(
          "/teacher/view_point_teacher/viewpointList",
          {
            page,
            type: this.viewType,
          }
        );
        var list_new = res.data.list.data,
          quotationList = this.quotationList;
        if (list_new.length) {
          this.quotationList = quotationList.concat(list_new);
          this.page++;
        } else {
          this.isEnd = true;
        }
        this.quotationListloading = false;
      }
    },
    searchView() {
      this.quotationList = [];
      this.isEnd = false;
      this.getViewpointList(1);
    },
    load() {
      this.getViewpointList(this.page);
    },
    //删除行情-弹框
    delConfirm(id) {
      this.$confirm("确认删除该行情吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del(id);
        })
        .catch(() => {});
    },
    //删除行情
    async del(id) {
      const res = await request.post(
        "/teacher/view_point_teacher/delViewpoint",
        { id }
      );
      this.$message({
        type: "success",
        message: "删除成功!",
      });
      this.quotationList = [];
      this.page = 1;
      this.isEnd = false;
      this.getViewpointList(1);
    },
  },
};
</script>

<style scoped>
.body {
  height: 100vh;
}

.w40 {
  height: 100%;
  border-right: 1px solid #ebeced;
}

.w60 {
  height: 100%;
}

.plate_title {
  background-color: #f8fcff;
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  padding: 18px 0;
  border-top: 1px solid #ebeced;
  border-bottom: 1px solid #ebeced;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.plate_title_name {
  position: relative;
  line-height: 16px;
  padding-left: 30px;
}

.plate_title_name::before {
  content: "";
  position: absolute;
  left: 13px;
  width: 4px;
  height: 16px;
  background-color: #5389f5;
  border-radius: 5px;
}

.choose_cell {
  font-size: 14px;
  display: flex;
  box-sizing: border-box;
  padding: 20px 0 10px;
  border-bottom: 1px dashed #dedede;
}

.choose_cell > div:first-child {
  font-weight: 600;
  flex-shrink: 0;
}

.choose_cell > div:last-child {
  color: #666;
  flex-wrap: wrap;
}

.choose_cell > div:last-child > div > span {
  cursor: pointer;
  margin-right: 15px;
  margin-bottom: 10px;
  display: block;
}

.choose_cell > div:last-child > div > span:hover {
  color: red;
}

.active {
  color: red;
}

.h300 {
  height: 300px !important;
}

.h300 /deep/.el-textarea__inner {
  height: 100%;
}

.mt_btn {
  margin-top: 31px;
}

.avatar-uploader_div {
  width: 148px;
  height: 148px;
  display: block;
  position: relative;
}

.avatar-uploader .avatar {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.zhezhao {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.zhezhao:hover {
  opacity: 1;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

/deep/.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  text-align: center;
}

.overflow_y {
  overflow-y: auto;
}

.overflow_y::-webkit-scrollbar {
  display: block;
  width: 4px;
}

.overflow_y::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px #aaa;
  background: rgba(0, 0, 0, 0.2);
}

.overflow_y::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #aaa;
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.quotation_body {
  box-sizing: border-box;
  padding: 0 20px;
  height: calc(100% - 54px);
}

.image_group {
  height: calc(100% - 60px);
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 20px;
  align-content: flex-start;
}

.image_box {
  width: 180px;
}

.image_cell {
  position: relative;
  width: 180px;
  height: 120px;
  border-radius: 4px;
  overflow: hidden;
}

.cover_img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.bottom_cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 5px;
}

.btn_delete {
  cursor: pointer;
  user-select: none;
  color: red;
}

.quotation .info {
  flex-shrink: 0;
  width: 92px;
  margin-right: 15px;
}

.quotation .time {
  font-size: 14px;
  color: #666666;
}

.icon_guonei,
.icon_guoji {
  width: 80px;
  margin-top: 5px;
}

.quotation_trend_zhang,
.quotation_trend_die {
  margin-top: 5px;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 4px 10px;
}

.quotation_trend_zhang {
  color: #ff3f30;
  background-color: #ffeceb;
}

.quotation_trend_die {
  color: #09c28e;
  background-color: #edfaf4;
}

.icon_zhang,
.icon_die {
  width: 10px;
  margin-left: 5px;
}

.quotation_cover {
  width: 150px;
  height: 90px;
  object-fit: cover;
  margin-right: 10px;
}

.quotation .title {
}

.quotation .desc {
  margin-top: 10px;
  color: #111;
}

.quotation_bottom {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.quotation_jiaoyisuo {
  font-size: 12px;
  font-weight: 500;
  color: #8b30ff;
  line-height: 0;
  box-sizing: border-box;
  padding: 0 10px;
  background: #f3eaff;
  border-radius: 12px 0px;
  height: 20px;
  display: flex;
  align-items: center;
}

.quotation_jiaoyisuo img {
  width: 11px;
  height: 11px;
  margin-right: 5px;
}

.quotation .operation {
  color: red;
  cursor: pointer;
  margin-left: 10px;
}

.is_end {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 12px 0;
  font-size: 12px;
  color: #ccc;
}

.kuaixun_detail {
  width: 353px;
  background-color: #fff;
  position: relative;
  padding: 120px 0 25px;
  margin-top: 5%;
}

.kuaixun_detail .info_body {
  margin: 0 auto;
  width: calc(100% - 50px);
  background-color: #ffffff;
  /* box-shadow: 2px 2px 6px 0px #e3e8f3; */
  border: 1px solid #e3e8f3;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 11px;
  position: relative;
}

.kuaixun_detail .info_body_head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e4e4;
  padding: 11px 0;
}

.kuaixun_detail .kuaixun_icon {
  width: 77px;
  height: 22px;
  display: block;
}

.kuaixun_detail .time {
  font-size: 12px;
  font-weight: 400;
  color: #a1a1a1;
}

.kuaixun_detail .title {
  font-size: 16px;
  font-weight: bold;
  color: #202020;
  margin-top: 9px;
  text-align: justify;
  padding: 0 4px;
  box-sizing: border-box;
  word-break: break-all;
}

.kuaixun_detail .content {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #1c1c1c;
  text-align: justify;
  padding: 0 4px;
  box-sizing: border-box;
  word-break: break-all;
}

.kuaixun_detail .kuaixun_bg_1 {
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
}

.kuaixun_detail .kuaixun_bg_2 {
  width: 318px;
  height: 58px;
  display: block;
  margin: 31px auto 0;
  position: relative;
}

.post_img {
  width: 100%;
  display: block;
  margin-top: 5px;
}
</style>
